<template>
  <CModal
    title="ข้อมูลผู้ใช้งาน"
    :show.sync="isShow"
    :closeOnBackdrop="false"
    @update:show="closeModal"
    centered
    size="xl"
  >
    <CRow>
      <CCol md="5" sm="12">
        <CCard>
          <CCardBody>
            <CRow>
              <CCol>
                <div>
                  <div>
                    <CImg
                      :src="user.userProfileUrl"
                      width="67"
                      height="67"
                      class="mx-auto"
                      placeholderColor="lightgray"
                      block
                    />
                  </div>
                  <div class="title-name">{{ user.fullName }}</div>
                </div>
                <div>
                  <div class="detail-key">Email</div>
                  <div class="detail-value">{{ user.email || '-' }}</div>
                </div>
                <div class="mt-2">
                  <div class="detail-key">เพศ</div>
                  <div class="detail-value">
                    {{ user.gender | genderFormat }}
                  </div>
                </div>
                <div class="mt-2">
                  <div class="detail-key">เบอร์โทรศัพท์</div>
                  <div class="detail-value">{{ user.phoneNo || '-' }}</div>
                </div>
                <div class="mt-2">
                  <div class="detail-key">ประเภทผู้ใช้</div>
                  <div class="detail-value">
                    {{ user.statusName | userStatusFormat }}
                  </div>
                </div>
                <div class="mt-2">
                  <div class="detail-key">วันที่สมัครสมาชิก</div>
                  <div class="detail-value">
                    {{ user.registeredAt | datetimeFormat }}
                  </div>
                </div>
                 <div class="mt-2">
                  <div class="detail-key">User ID</div>
                  <div class="detail-value">{{ user.user_id || '-' }}</div>
                </div>
                <div class="mt-2">
                  <div class="detail-key">Facebook ID</div>
                  <div class="detail-value">{{ user.facebookId || '-' }}</div>
                </div>
                <div class="mt-2">
                  <div class="detail-key">Last Seen Date</div>
                  <div class="detail-value">
                    {{ user.lastLogoutAt | datetimeFormat }}
                  </div>
                </div>
                <div class="mt-2">
                  <div class="detail-key">จำนวนหนังสือที่สร้าง</div>
                  <div class="detail-value">{{ countBook() }}</div>
                </div>
                <div class="mt-2">
                  <div class="detail-key">จำนวนบทความที่สร้าง</div>
                  <div class="detail-value">{{ countArticle() }}</div>
                </div>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md="7" sm="12">
        <CCard>
          <CCardHeader>
            หนังสือ / บทความ ที่สร้าง
          </CCardHeader>
          <CCardBody v-if="books.length > 0">
            <vue-good-table
              :columns="columns"
              :rows="books"
              max-height="500px"
              :fixed-header="true"
              theme="black-rhino"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'percent'">
                  {{ props.row.percent }}%
                </span>
                <span v-else-if="props.column.field === 'detail'">
                  {{ props.row.detail || 'ไม่ระบุ' }}
                </span>
              </template>
            </vue-good-table>
          </CCardBody>
          <CCardBody v-else align="center">
            ไม่พบข้อมูล
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <template slot="footer">
      <CButton color="primary" @click="confirm">
        ปิด
      </CButton>
    </template>
  </CModal>
</template>

<script>
import _ from 'lodash'

import apiBookCategory from '@/apis/book_category'
import apiUser from '@/apis/user'

export default {
  name: 'UserInfoModal',
  data() {
    return {
      isShow: false,
      books: [],
      user: {},
      columns: [
        {
          label: 'ชื่อหนังสือ / บทความ',
          field: 'name',
          sortable: false
        },
        {
          label: 'รายละเอียด',
          field: 'detail',
          sortable: false
        },
        {
          label: 'ความสมบูรณ์',
          field: 'percent',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'ประเภท',
          field: 'type',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center'
        }
      ]
    }
  },
  methods: {
    show(id) {
      this.isShow = true
      apiUser
        .detail(id)
        .then((result) => {
          this.books = result.data.books
          this.user = result.data.user
        })
        .catch(() => {})
    },
    clear() {
      setTimeout(() => {
        this.info = {
          id: '',
          type: ''
        }
      }, 500)
    },
    confirm() {
      this.isShow = false
      this.clear()
    },
    closeModal() {
      this.clear()
    },
    countBook() {
      const data = _.filter(this.books, { typeName: 'book' })
      return data.length
    },
    countArticle() {
      const data = _.filter(this.books, { typeName: 'article' })
      return data.length
    }
  }
}
</script>
<style scope>
.title-name {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  margin: 16px 0;
}
</style>
